// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { bitkubTestnet as _bitkubTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the bitkubTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 25925
 * Chain Name: Bitkub Testnet
 * Default Block Explorer: https://testnet.bkcscan.com
 * Default RPC URL: https://rpc-testnet.bitkubchain.io
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { bitkubTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: bitkubTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const bitkubTestnet = createCommon({
	..._bitkubTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
